import { render, staticRenderFns } from "./fccEditarProjeto.vue?vue&type=template&id=07434639"
import script from "./fccEditarProjeto.vue?vue&type=script&lang=js"
export * from "./fccEditarProjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports